<template>
<div class="fc-page ca-page ca-page-cash_reduce_order"><header class="fc-child-heading"><h2>手工扣费订单</h2><p>查询手工扣费记录及撤销状态</p></header><section class="fc-filters" aria-label="手工扣费订单筛选"><div class="fc-filter-heading"><h3>筛选条件</h3><span>查询手工扣费记录及撤销状态</span></div><form @submit.prevent="queryClicked"><div class="fc-filter-grid"><div class="fc-filter-cell"><v-text-field clearable dense label="订单ID" outlined v-model="query.id" color="#d9363e" hide-details>
								</v-text-field></div><div class="fc-filter-cell"><v-text-field clearable dense label="学员姓名" outlined v-model="query.studentName" color="#d9363e" hide-details>
								</v-text-field></div><div class="fc-filter-cell"><v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
								    transition="scale-transition" offset-y
									min-width="auto">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field v-model="query.start" label="开始日期" readonly v-bind="attrs" v-on="on"
											dense clearable outlined color="#d9363e" hide-details></v-text-field>
									</template>
									<v-date-picker v-model="query.start"  @input="menu1=false" no-title scrollable locale="zh-cn" color="#d9363e">
									</v-date-picker>
								</v-menu></div><div class="fc-filter-cell"><v-menu ref="menu2" v-model="menu2" :close-on-content-click="false"
									 transition="scale-transition" offset-y min-width="auto">
									<template v-slot:activator="{ on, attrs }">
										<v-text-field v-model="query.end" label="结束日期" readonly v-bind="attrs" v-on="on"
											dense clearable outlined color="#d9363e" hide-details></v-text-field>
									</template>
									<v-date-picker v-model="query.end" @input="menu2=false" no-title scrollable locale="zh-cn" color="#d9363e">
									</v-date-picker>
								</v-menu></div><div class="fc-filter-cell"><v-select :items="statusItems" v-model="query.status" item-text="statusName" item-value="id"
									label="订单状态" dense outlined color="#d9363e" hide-details></v-select></div></div><div class="fc-filter-bottom"><span>查询当前校区的记录</span><div class="fc-filter-actions"><v-btn type="submit" depressed dark color="#d9363e" :loading="query.loading"><v-icon left size="17">mdi-magnify</v-icon>查询</v-btn></div></div></form></section><section class="fc-records"><div class="fc-list-heading"><h3>手工扣费明细</h3><span class="fc-count">共 <strong>{{data.total}}</strong> 条</span></div><v-data-table :headers="data.headers" :items="data.list" :loading="query.loading" class="fc-table ca-table ca-cash_reduce_order fc-has-actions" :mobile-breakpoint="0"
				disable-pagination hide-default-footer item-key="id" loading-text="正在加载，请稍候…" no-data-text="暂无符合条件的记录">

				<template v-slot:item.status="{item}">

					<span v-if="item.status =='1'" class="fc-status fc-status-normal">正常</span>
					<span v-if="item.status =='0'" class="fc-status fc-status-inactive">已撤销</span>
				</template>
				<template v-slot:item.action="{item}">
					<v-btn @click="cancelOrder(item)"  color="#c93640" outlined small  :disabled="item.status =='0'">撤销</v-btn>
				</template>

			<template v-slot:item.studentName="{item}"><strong class="fc-student-name">{{item.studentName}}</strong></template><template v-slot:item.memo="{item}"><div class="fc-memo">{{item.memo}}</div></template><template v-slot:item.reduceAmount="{item}"><span class="fc-number" :class="{'fc-negative':Number(item.reduceAmount)<0}">{{item.reduceAmount}}</span></template><template v-slot:item.reduceCash="{item}"><span class="fc-number" :class="{'fc-negative':Number(item.reduceCash)<0}">{{item.reduceCash}}</span></template></v-data-table><div class="fc-pagination"><div class="fc-page-size"><span>每页</span><v-select :items="[10,20,50,100]" @change="handleSizeChange" dense hide-details aria-label="每页数量" outlined v-model="query.size" color="#d9363e" /><span>条</span><span class="fc-total">共 {{data.total}} 条记录</span></div><v-pagination v-if="Math.ceil(data.total/query.size)>0" :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange" :total-visible="5" v-model="query.page" color="#d9363e" /></div></section><v-dialog title="确定撤销扣费" v-model="cancel.dialog" max-width="600" persistent scrollable>
			<v-card class="fc-dialog-card ca-dialog">
				<v-card-title class="fc-dialog-header"><span class="fc-dialog-symbol"><v-icon color="#d9363e" size="24">mdi-file-document-remove-outline</v-icon></span><div><h2>撤销扣费订单</h2><p>请核对订单信息，确认后更新账户余额</p></div><v-spacer /><v-btn icon aria-label="关闭撤销扣费订单" @click="cancel.dialog=false"><v-icon size="22">mdi-close</v-icon></v-btn></v-card-title>

				<v-card-text class="fc-dialog-body">
					<v-sheet class="fc-form-sheet">

						<v-row class="" dense>
							<v-col cols="6">
								<v-text-field label="订单时间" disabled v-model="cancel.order.createAt" dense
									outlined color="#d9363e"></v-text-field>
							</v-col>

							<v-col cols="6">
								<v-text-field label="姓名" disabled v-model="cancel.order.studentName" dense
									outlined color="#d9363e"></v-text-field>
							</v-col>
							<v-col cols="6">
								<v-text-field label="学费金额" disabled v-model="cancel.order.reduceAmount" dense
									outlined color="#d9363e"></v-text-field>
							</v-col>
							<v-col cols="6">
								<v-text-field label="现金金额" disabled v-model="cancel.order.reduceCash" dense
									outlined color="#d9363e"></v-text-field>
							</v-col>
						</v-row>
					</v-sheet>
				</v-card-text>
				<v-card-actions class="fc-dialog-actions">
					<v-spacer></v-spacer>
					<v-btn @click="cancel.dialog=false">取消</v-btn>
					<v-btn @click="submitCancelOrder" :disabled="cancel.submitting" :loading="cancel.submitting" class="fc-confirm" depressed color="#d9363e">确认撤销</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog></div>
</template>

<script>
	import utils from "../../../config/utils"
	export default {
		name: "reduce-order-list",
		data() {
			return {
				menu1: false, // 开始时间菜单
				menu2: false, // 结束时间菜单
				
				data: {
					total: 0,
					headers: [
						{
							text: '订单ID',
							value: 'id',
							sortable: false
						},
						{
							text: '时间',
							value: 'createAt',
							sortable: false
						},
						{
							text: '姓名',
							value: 'studentName',
							sortable: false
						},
						{
							text: '扣除金额',
							value: 'reduceAmount',
							sortable: false
						},
						
						{
							text: '扣除现金',
							value: 'reduceCash',
							sortable: false
						},
						{
							text: '状态',
							value: 'status',
							sortable: false
						},
						{
							text: '操作人',
							value: 'creatorName',
							sortable: false
						},
						{
							text: '备注',
							value: 'memo',
							sortable: false
						},
						{
							text: '操作',
							align: 'center',
							value: 'action',
							sortable: false
						},
					],
					list: [],
				},
				statusItems: [{
						id: "",
						statusName: "全部"
					},
					{
						id: "1",
						statusName: "正常"
					},
					{
						id: "0",
						statusName: "已撤销"
					},
				],
				query: {
					loading: false,
					page: 1,
					size: 20,
					id:"",
					start: "",
					end: "",
					status:""
				},
				cancel:{
					dialog:false,
					submitting:false,
					order:{}
				}
			}
		},
		created() {
			this.getTableDataList();
		},
		computed:{
			// 总缴费汇总
			sumTotalRechargeAmount(){
				let result = 0;
				if(this.data.list){
					this.data.list.forEach((item,index)=>{
						result = result+ parseFloat(item.payFee);
					})
				}
				
				return result.toFixed(2);
			},
			sumTotalCouponAmount(){
				let result = 0;
				if(this.data.list){
					this.data.list.forEach((item,index)=>{
						result = result+ parseFloat(item.couponFee);
					})
				}
				
				return result.toFixed(2);
			}
		},
		methods: {
			queryClicked(){
				this.query.page = 1;
				this.getTableDataList();
			},
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getTableDataList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getTableDataList();
			},
			
			getTableDataList() {
				const that = this;
				this.query.loading = true;

				const shopId = utils.getCurrentShopId();
				let url = `/financial/reduce/order/list/2/page/${that.query.page - 1}/size/${that.query.size}?v=1`;
				if (shopId) {
					url += "&shopId=" + shopId;
				}
				if (this.query.id) {
					url += "&id=" + this.query.id;
				}
				if (this.query.start) {
					url += "&start=" + this.query.start;
				}
				if (this.query.end) {
					url += "&end=" + this.query.end;
				}
				if (this.query.studentName) {
					url += "&studentName=" + this.query.studentName;
				}
				if (this.query.status) {
					url += "&status=" + this.query.status;
				}
				
				this.axios.get(url).then(response => {
					
					if (response.data["code"] === 200) {
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];

						that.query.loading = false;
						return
					}
					that.query.loading = false;
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
			
			statusName(state) {

				let stName = "未知";
				if (state === "1") {
					stName = "正常";
				} else if (state === "0") {
					stName = "已取消";
				}
				return stName;
			},
			statusColor(state) {
				let color = "";
				if (state === "1") {
					color = "success";
				} else if (state === "0") {
					color = "error";
				}

				return color;
			},
		
			cancelOrder(item){
				this.cancel.order = item;
				this.cancel.dialog=true;
			},
			submitCancelOrder(){
				//提交作废
				this.cancel.submitting = true;
				// api
				const that = this;
				let url = `/financial/reduce/order/cancel/${this.cancel.order.id}`;
				
				
				this.axios.post(url, {}).catch(() => {
					that.cancel.submitting = false;
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");
							that.getTableDataList();
							that.cancel.dialog = false;
							that.cancel.submitting = false;
							return;
						} else {
							that.cancel.submitting = false;
							that.$noty.error("操作失败," + res.data["message"]);
						}
					} else {
						that.cancel.submitting = false;
						that.$noty.error('网络请求失败');
					}
				
				});
				
			}
		}
	}
</script>

<style lang="scss" scoped src="../../../assets/styles/cash-account.scss"></style>
